import React from 'react';

import {BackendSourceOptions, DiscoveryItemClickEvent} from '@udemy/browse-event-tracking';
import {DiscoveryUnit} from '@udemy/discovery-api';
import {generateTrackingId, Tracker} from '@udemy/event-tracking';
import {useI18n} from '@udemy/i18n';
import {PopularTopicsDiscoveryItem, PopularTopicsUnit} from '@udemy/react-discovery-units';

import {getConfig} from 'src/features/cart/config';

export const PopularTopicsUnitComponent = () => {
    const {gettext, interpolate, ngettext} = useI18n();
    const config = getConfig(gettext, interpolate, ngettext);

    const popularTopics = {
        title: 'Unit Title',
        type: 'popular_topics',
        view_type: 'horizontal_tabbed',
        items: [
            {
                id: 158078,
                title: config.strings.popularTopicsItems.generativeAI,
                url: '/topic/generative-ai/',
            },
            {
                id: 132,
                title: config.strings.popularTopicsItems.itCertifications,
                url: '/courses/it-and-software/it-certification/',
            },
            {
                id: 5336,
                title: config.strings.popularTopicsItems.dataScience,
                url: '/topic/data-science/',
            },
            {
                id: 158002,
                title: config.strings.popularTopicsItems.chatGPT,
                url: '/topic/chatgpt/',
            },
            {
                id: 158142,
                title: config.strings.popularTopicsItems.promptEngineering,
                url: '/topic/prompt-engineering/',
            },
            {
                id: 6730,
                title: config.strings.popularTopicsItems.microsoftExcel,
                url: '/topic/excel/',
            },
            {
                id: 643646,
                title: config.strings.popularTopicsItems.largeLanguageModels,
                url: '/topic/large-language-models/',
            },
            {
                id: 6594,
                title: config.strings.popularTopicsItems.machineLearning,
                url: '/topic/machine-learning/',
            },
            {
                id: 583042,
                title: config.strings.popularTopicsItems.aiAgents,
                url: '/topic/ai-agents/',
            },
        ],
    } as DiscoveryUnit<PopularTopicsDiscoveryItem>;

    return (
        <>
            <PopularTopicsUnit
                unit={{
                    ...popularTopics,
                    title: config.strings.popularTopics,
                }}
                trackTopicClick={(topicId) => {
                    Tracker.publishEvent(
                        new DiscoveryItemClickEvent({
                            id: parseInt(topicId),
                            type: 'course_topic',
                            trackingId: topicId,
                            serveTrackingId: generateTrackingId(),
                            backendSource: BackendSourceOptions.SHOPPING_CARTS,
                            badgeFamilies: null,
                            uiRegion: 'popular-topics-unit',
                        }),
                    );
                }}
                titleTypography={'ud-heading-lg'}
            />
        </>
    );
};
